/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect, useState } from 'react';
import { useMediaQuery, Button, Grid } from '@material-ui/core';
import { useGlobal, SelectCustom } from '@rcg/ui-react';
import { Card, CardContent, CardActions } from '@rcg/ui-react/lib/components';
import TextField from '../../components/TextField';
import useStyles from './index.style';
import theme from '../../theme/booking-theme';
import { getDays, getMonths, getYears } from '../../commons/dateObjetcs';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../commons/dictionary';
import { setSessionStorageItem } from '../../commons/utils';
import { MAIN_PROFILE_BOOKING_ID } from '../../commons/constants';

const Fields = (props) => {
  const {
    disabledAllFields,
    errors,
    handleChange,
    hideSubmitButton = false,
    isValid,
    setFieldTouched,
    touched,
    searchSailings,
    ships,
    values: { rsvNumber, lastName },
    reinitializeForm,
  } = props;
  const {
    data: { localizedDayjs },
  } = useGlobal();
  const getDictionary = useDictionary(Dictionary);
  const placeholderColor = theme.palette.grey8;
  const activeColor = theme.palette.grey1;
  const classes = useStyles();
  const [ship, setShip] = useState('none');
  const [year, setYear] = useState('none');
  const [month, setMonth] = useState('none');
  const [day, setDay] = useState('none');
  const [shipOptions, setShipOptions] = useState([]);
  const [yearsObj, setYearsObj] = useState([]);
  const [monthsObj, setMonthsObj] = useState([]);
  const [daysObj, setDaysObj] = useState([]);

  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  useEffect(() => {
    if (reinitializeForm) {
      setShip('none');
      setYear('none');
      setMonth('none');
      setDay('none');
    }
    // eslint-disable-next-line
  }, [reinitializeForm]);

  useEffect(() => {
    if (searchSailings) {
      const shipMap =
        (searchSailings &&
          ships &&
          ships
            .filter(({ code }) => {
              return searchSailings.shipSailings.some(
                (shipSailing) => shipSailing.shipCode === code,
              );
            })
            .map(({ name, code }) => {
              const shipName = name
                .toLowerCase()
                .replace(/(?:^|\s)(?!of|the)\S/g, (a) => a.toUpperCase());
              return { label: shipName, value: code };
            })) ||
        [];
      const selectedShipSailings =
        searchSailings && searchSailings.shipSailings.find((item) => item.shipCode === ship);
      const sailingDates = selectedShipSailings && selectedShipSailings.sailingDates;
      const yearsObjMap = sailingDates && getYears(sailingDates);
      const monthsObjMap = sailingDates && getMonths(sailingDates, year, localizedDayjs, isDesktop);
      const dates = sailingDates && getDays(sailingDates, year, month, localizedDayjs);
      const daysObjMap =
        dates &&
        dates.map((date) => {
          return { label: date, value: date };
        });
      setShipOptions(shipMap);
      setYearsObj(yearsObjMap);
      setMonthsObj(monthsObjMap);
      setDaysObj(daysObjMap);
    }
    // eslint-disable-next-line
  }, [searchSailings, ship, year, month, day]);

  const submit = (event) => {
    event.preventDefault();
    setSessionStorageItem(MAIN_PROFILE_BOOKING_ID, '');
    props.login({
      variables: {
        bookingId: props.values.rsvNumber,
        lastName: props.values.lastName,
        sailDate: `${year}-${month}-${day}`,
        shipCode: ship,
      },
    });
  };

  const handleChangeValue = (name, e) => {
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  const handleReservationNumber = (e) => {
    handleChangeValue('rsvNumber', e);
  };

  const handleLastName = (e) => {
    handleChangeValue('lastName', e);
  };

  const shipsHandler = (event) => {
    setShip(event.target.value);
    setYear('none');
    setMonth('none');
    setDay('none');
  };

  const yearHandler = (event) => {
    setYear(event.target.value);
    setMonth('none');
    setDay('none');
  };
  const monthHandler = (event) => {
    setMonth(event.target.value);
    setDay('none');
  };
  const dayHandler = (event) => {
    setDay(event.target.value);
  };

  const formIsValid =
    isValid && year !== 'none' && month !== 'none' && day !== 'none' && ship !== 'none';

  return (
    <form onSubmit={submit} className={classes.root}>
      <Card>
        <CardContent>
          <Grid container mt={3}>
            <Grid item lg={6} md={6} xs={12} sm={12} className={classes.textFields}>
              <TextField
                inputProps={{
                  'data-testid': 'login-rsv-number',
                  inputMode: 'numeric',
                  maxLength: 7,
                  pattern: '[0-9]*',
                }}
                disabled={disabledAllFields}
                error={touched.rsvNumber && Boolean(errors.rsvNumber)}
                helperText={touched.rsvNumber ? errors.rsvNumber : ''}
                id="rsvNumber"
                label={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>
                      {getDictionary(Dictionary.formBookingAmendFieldReservationNumberLabel.key)}
                    </span>
                  </div>
                }
                autoComplete="transaction-amount"
                onChange={handleReservationNumber}
                placeholder={getDictionary(Dictionary.formBookingAmendFieldReservationNumber.key)}
                value={rsvNumber}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12} sm={12} className={classes.textFields}>
              <TextField
                inputProps={{ 'data-testid': 'last-name' }}
                disabled={disabledAllFields}
                error={touched.lastName && Boolean(errors.lastName)}
                helperText={touched.lastName ? errors.lastName : ''}
                id="lastName"
                label={getDictionary(Dictionary.formBookingAmendFieldLastNameLabel.key)}
                onChange={handleLastName}
                placeholder={getDictionary(Dictionary.formBookingAmendFieldLastName.key)}
                value={lastName}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={12} sm={12} className={classes.selectShip}>
              <SelectCustom
                menuClassName={classes.optionsHeight}
                isMobile={false}
                options={shipOptions}
                id="ship-select"
                selectLabel={getDictionary(Dictionary.formBookingAmendFieldShipLabel.key)}
                placeholder={getDictionary(Dictionary.formBookingAmendFieldShip.key)}
                currentValue={ship}
                defaultColor={ship === 'none' ? placeholderColor : activeColor}
                handleOption={shipsHandler}
                dataTestid="ship-select"
              />
            </Grid>
            <Grid item container lg={6} md={6} xs={12} sm={12} className={classes.dateInputs}>
              <Grid item xs={4}>
                <SelectCustom
                  isMobile={false}
                  options={yearsObj}
                  selectLabel={getDictionary(Dictionary.amendLookUpFieldSailingDateLabel.key)}
                  placeholder={getDictionary(Dictionary.amendLookUpFieldYearLabel.key)}
                  currentValue={year}
                  defaultColor={year === 'none' ? placeholderColor : activeColor}
                  handleOption={yearHandler}
                  dataTestid="year-select"
                  selectClassName={classes.dateInputs}
                  disabled={ship === 'none'}
                />
              </Grid>
              <Grid item xs={4}>
                <SelectCustom
                  isMobile={false}
                  options={monthsObj}
                  selectLabel=""
                  placeholder={getDictionary(Dictionary.amendLookUpFieldMonthLabel.key)}
                  currentValue={month}
                  defaultColor={month === 'none' ? placeholderColor : activeColor}
                  handleOption={monthHandler}
                  selectClassName={classes.dateInputs}
                  dataTestid="month-select"
                  disabled={year === 'none'}
                />
              </Grid>
              <Grid item xs={4}>
                <SelectCustom
                  isMobile={false}
                  options={daysObj}
                  selectLabel=""
                  placeholder={getDictionary(Dictionary.amendLookUpFieldDayLabel.key)}
                  currentValue={day}
                  defaultColor={day === 'none' ? placeholderColor : activeColor}
                  handleOption={dayHandler}
                  selectClassName={classes.dateInputs}
                  dataTestid="day-select"
                  disabled={month === 'none'}
                />
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        {!hideSubmitButton && (
          <CardActions>
            <Grid sm={12} xs={12} item classes={{ root: 'actions' }}>
              <Button
                data-testid="login-submit"
                className={classes.buttons}
                color="primary"
                disabled={!formIsValid}
                type="submit"
                variant="contained">
                {getDictionary(Dictionary.formBookingAmendButtonSubmit.key)}
              </Button>
            </Grid>
          </CardActions>
        )}
      </Card>
    </form>
  );
};

export default Fields;
